import Skeleton from "react-loading-skeleton";

import Box from "ds/components/Box";
import TileContent from "ds/components/Tile/Content";
import TileWrapper from "ds/components/Tile/Wrapper";

import { DASHBOARD_WIDGETS_OPEN_TOFU_MIGRATION_LIST_LIMIT } from "../constants";

const ROWS = Array(DASHBOARD_WIDGETS_OPEN_TOFU_MIGRATION_LIST_LIMIT).fill(null);

const DashboardWidgetsOpenTofuMigrationListSkeleton = () => (
  <>
    {ROWS.map((_, i) => (
      <TileWrapper key={i}>
        <TileContent>
          <Box justify="between" align="center">
            <Skeleton inline count={1} height={18} width={170} />
            <Skeleton inline count={1} height={18} width={60} />
          </Box>
        </TileContent>
      </TileWrapper>
    ))}
  </>
);

export default DashboardWidgetsOpenTofuMigrationListSkeleton;
